import Swiper from "swiper";
import "swiper/css/swiper.min.css";

export default { Swiper };
